import moment from 'moment-mini';
export const getDropOptionLabel = (option) => {
    return `${option.campaignName} (LD: ${moment.utc(option.liveDate).format('MM/DD/YYYY HH:mm A')})`;
};
